import { ENV } from '../../config/runtimeEnv';

import { DietScoresResponse, ExerciseScoresResponse } from '../../types/geneCodes/GeneticScoringTypes';
import { http } from '../../lib/http/client';

const API_BASE_URL = ENV.VITE_LABIQ_SERVER || '';

export const fetchDietScores = async (sampleId: string): Promise<DietScoresResponse> => {
	const response = await http.get(`${API_BASE_URL}/diet-scores`, {
		params: { sample_id: sampleId },
	});

	return response.data;
};

export const fetchExerciseScores = async (sampleId: string): Promise<ExerciseScoresResponse> => {
	const response = await http.get(`${API_BASE_URL}/exercise-scores`, {
		params: { sample_id: sampleId },
	});

	return response.data;
};
